module.exports = ".buttonStyle{\n    width: 50%;\n    padding: 0;\n    text-align: center;\n    margin: 0 !important;\n}"